import ru from "./ru.json";
import ua from "./ua.json";

export const defaulLocale = "ua";

export const languages = {
    ua,
    ru,
};
